import { makeVar } from "@apollo/client";
import { SelectionProcess } from "../interfaces";

export interface IWorklistToolInternalState {
  setCtrlDown: boolean;
  destSelectionProcess: SelectionProcess;
  randomizeWells: boolean;
  errorMessages: { [key: string]: string };
}

export const WorklistToolInternalState = makeVar<IWorklistToolInternalState>({
  setCtrlDown: false,
  destSelectionProcess: SelectionProcess.Stamp,
  randomizeWells: false,
  errorMessages: {},
});
